import DOMPurify from "dompurify";

const allowedTags = [
  "a",
  "b",
  "blockquote",
  "br",
  "div",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "i",
  "li",
  "ol",
  "p",
  "span",
  "strong",
  "u",
  "ul",
];
const allowedAttributes = ["href", "rel", "style", "target"];
const allowedStyles = new Set([
  "background-color",
  "color",
  "font-size",
  "font-style",
  "font-weight",
  "line-height",
  "text-align",
  "text-decoration",
]);

function sanitizeStyles(styleText) {
  return styleText
    .split(";")
    .map((rule) => rule.trim())
    .filter((rule) => allowedStyles.has(rule.split(":")[0]?.trim().toLowerCase()))
    .join("; ");
}

export function sanitizeHtml(html) {
  const sanitized = DOMPurify.sanitize(html || "", {
    ALLOWED_ATTR: allowedAttributes,
    ALLOWED_TAGS: allowedTags,
    ALLOW_DATA_ATTR: false,
    ALLOWED_URI_REGEXP: /^(?:https?:\/\/)/i,
  });
  const document_ = new DOMParser().parseFromString(sanitized, "text/html");

  document_.querySelectorAll("[style]").forEach((element) => {
    const safeStyle = sanitizeStyles(element.getAttribute("style") || "");
    if (safeStyle) {
      element.setAttribute("style", safeStyle);
    } else {
      element.removeAttribute("style");
    }
  });
  document_.querySelectorAll("a").forEach((link) => {
    link.setAttribute("rel", "noreferrer noopener");
    link.setAttribute("target", "_blank");
  });

  return document_.body.innerHTML;
}

export default function SafeHtmlContent({ html }) {
  return <div className="safe-html-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />;
}
